import Empty from '@/views/Empty';
import Completion from '@/views/pages/completion/Index';

export default {
  path: 'completion',
  component: Empty,
  meta: {},
  children: [
    {
      path: '',
      name: 'Completion',
      component: Completion,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/completion.js